import {
    evaluateExperiment,
    logExperiment
} from '@homeaway/abacus-client-utils';

import {
    hasEmptyDestinationValues,
    hasEmptyDatesValues,
    hasEmptyGuestsValues,
    hasHPPageType,
    hasSLPPageType
} from './';

const EXPERIMENT_NAMES = [];

/* istanbul ignore next */
function hasAllowableFullExposureExperiment() {
    return true;
}

function hasRunnableAnyVariantExperiment(experiment) {
    return experiment.value > 0;
}

function hasValidExperiment(experiment) {
    return experiment && !experiment.exception;
}

function runExperiment(experimentName, {
    hasAllowableExperiment, // = hasAllowableFullExposureExperiment
    hasRunnableExperiment = hasRunnableAnyVariantExperiment
}) {
    const experiment = evaluateExperiment(experimentName);

    if (hasValidExperiment(experiment) && hasAllowableExperiment(experiment)) {
        logExperiment(experiment);

        return hasRunnableExperiment(experiment);
    }

    return false;
}

function runHPPrePopulateCookieExperiment(cookies, system) {
    return runExperiment('HA_HP_SEARCHFORM_PRE_POPULATE_COOKIE', {
        hasAllowableExperiment() {
            const {
                destinationValues,
                datesValues,
                guestsValues
            } = cookies;

            return (
                hasHPPageType(system) && (
                    !hasEmptyDestinationValues(destinationValues) ||
                    !hasEmptyDatesValues(datesValues) ||
                    !hasEmptyGuestsValues(guestsValues)
                )
            );
        }
    });
}

function runSLPDatePickerOpenedExperiment(system) {
    return runExperiment('HA_PTA_SEARCHFORM_SLP_Datepickeropened', {
        hasAllowableExperiment() {
            return hasSLPPageType(system);
        }
    });
}

/* istanbul ignore next */
function runAllExperiments() {
    const results = {};

    for (const experimentName of EXPERIMENT_NAMES) {
        results[experimentName] = runExperiment(experimentName);
    }

    return results;
}

export {
    EXPERIMENT_NAMES,
    hasAllowableFullExposureExperiment,
    hasRunnableAnyVariantExperiment,
    hasValidExperiment,
    runAllExperiments,
    runExperiment,
    runHPPrePopulateCookieExperiment,
    runSLPDatePickerOpenedExperiment
};
